import { Grid } from "@mui/material"
import { styled } from "@mui/material/styles"
import PaperBox from "components/PaperBox"

export const StyledPaperBox = styled(PaperBox)({
  margin: 0,
  "& img": {
    maxWidth: "100%",
    height: "auto"
  }
})

export const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.between("md", "lg")]: {
    alignItems: "flex-start",
    flexDirection: "column"
  }
}))
